import { render, staticRenderFns } from "./b-proposal.vue?vue&type=template&id=2d984fa0&"
import script from "./b-proposal.vue?vue&type=script&lang=js&"
export * from "./b-proposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports